<template>
  <div ref="card" class="card">
    <slot />
  </div>
</template>
